module.exports = __webpack_public_path__ + "img/1_novice_closer.f4a0e436.png";